import { render, staticRenderFns } from "./newEvaluatorEdition.vue?vue&type=template&id=6cf9387c"
import script from "./newEvaluatorEdition.vue?vue&type=script&lang=js"
export * from "./newEvaluatorEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports